import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-dialog wise-modal" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "info-panel small-link mb-3 p-1" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { for: "ProductSku" }
const _hoisted_13 = {
  id: "ProductSku",
  class: "form-control"
}
const _hoisted_14 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_15 = {
  key: 0,
  class: "col-md-6 form-group"
}
const _hoisted_16 = { for: "ProductSku" }
const _hoisted_17 = {
  id: "ProductSku",
  class: "form-control"
}
const _hoisted_18 = { for: "PurchasePrice" }
const _hoisted_19 = {
  id: "PurchasePrice",
  class: "form-control numeric"
}
const _hoisted_20 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_21 = { for: "CostPrice" }
const _hoisted_22 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_23 = { for: "Quantity" }
const _hoisted_24 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_25 = { class: "modal-footer" }
const _hoisted_26 = { class: "d-flex justify-content-end" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_numeric_fld_input = _resolveComponent("numeric-fld-input")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{'d-none': !_ctx.visible}, "modal fade show"]),
    style: {"display":"block"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.windowTitle), 1),
          (!_ctx.isSavingRecord)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeFormRet && _ctx.closeFormRet(...args))),
                type: "button",
                class: "btn-close"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.language.po_qty), 1),
                _createTextVNode(": " + _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.thePurchaseDetailInfo.OrderQty)), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.language.in_stock), 1),
                _createTextVNode(": " + _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.thePurchaseDetailInfo.TasnsferQty)), 1)
              ]),
              _createElementVNode("div", {
                class: "col-md-4",
                title: _ctx.language.to_be_transf
              }, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.language.remaining), 1),
                _createTextVNode(": " + _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.thePurchaseDetailInfo.RemainQty)), 1)
              ], 8, _hoisted_10)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.ProductSku.$error}])
            }, [
              _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.language.product), 1),
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.theProductRecord.Name), 1),
              (_ctx.v$.dataRecord.ProductSku.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.v$.dataRecord.ProductSku.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ], 2),
            (_ctx.theProductType == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.language.variant), 1),
                  _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.theVariantValRecord.VariantValues), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.BuyingPrice.$error}])
            }, [
              _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.language.purchase_price), 1),
              _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.dataRecord.BuyingPrice)), 1),
              (_ctx.v$.dataRecord.BuyingPrice.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.v$.dataRecord.BuyingPrice.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.CostPrice.$error}])
            }, [
              _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.language.cost_price), 1),
              _createVNode(_component_numeric_fld_input, {
                modelValue: _ctx.dataRecord.CostPrice,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dataRecord.CostPrice) = $event)),
                class: "form-control",
                disabled: _ctx.isSavingRecord || _ctx.dataRecord.IdStockEntry != 0,
                placeholder: '(' + _ctx.language.cost_price.toLowerCase() + ')',
                maxlength: 15
              }, null, 8, ["modelValue", "disabled", "placeholder"]),
              (_ctx.v$.dataRecord.CostPrice.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.v$.dataRecord.CostPrice.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.Quantity.$error}])
            }, [
              _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.language.qty), 1),
              _createVNode(_component_numeric_fld_input, {
                modelValue: _ctx.dataRecord.Quantity,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dataRecord.Quantity) = $event)),
                class: "form-control",
                disabled: _ctx.isSavingRecord || _ctx.dataRecord.IdStockEntry != 0,
                placeholder: '(' + _ctx.language.qty.toLowerCase() + ')',
                maxlength: 15
              }, null, 8, ["modelValue", "disabled", "placeholder"]),
              (_ctx.v$.dataRecord.Quantity.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.v$.dataRecord.Quantity.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary me-2",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeFormRet && _ctx.closeFormRet(...args))),
              disabled: _ctx.isSavingRecord
            }, _toDisplayString(_ctx.language.close), 9, _hoisted_27),
            (_ctx.dataRecord.IdStockEntry == 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.saveRecordData && _ctx.saveRecordData(...args))),
                  disabled: _ctx.v$.$invalid || _ctx.isSavingRecord
                }, [
                  (_ctx.isSavingRecord)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 0,
                        icon: ['fa', 'fa-spinner']
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.isSavingRecord)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 1,
                        icon: ['fa', 'fa-save']
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.language.save), 1)
                ], 8, _hoisted_28))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 2))
}